import React, { useState } from 'react'
import { Checkbox, CheckboxGroup } from 'rsuite'

import { useTranslation } from 'react-i18next'

const ProductFilterForm = ({ title, data, columns=1, handleChange, taxonomyName, initialFilters }) => {

  const [ showAll, setShowAll ] = useState(initialFilters[taxonomyName]?.length > 0 || false)

  const { t, i18n } = useTranslation()
  const lang = i18n.language // get current language

  const handleCheckboxChange = (value) => {
    handleChange({
      "taxonomy": taxonomyName,
      "data": value
    })
  }

  console.log(initialFilters, taxonomyName)

  const dataList = showAll ? data : data.slice(0,4)

  return (
    <div className={`products-filter-single columns-${columns}`}>
      <div className="products-filter-single-title"><span>{title}</span></div>
      <div className="products-filter-single-content">
        <CheckboxGroup 
          onChange={v => handleCheckboxChange(v)}
          defaultValue={initialFilters[taxonomyName]}
        >
          {dataList ? (
            dataList.map(item => (
              <Checkbox 
                key={item.slug}
                value={item.id}
                name={item.slug}
              >
                {item.acf.names[`name_${lang}`]}
              </Checkbox>
            ))
          ) : (
            <span>{t("Opss... I can't find anything...")}</span>
          )}
          { !showAll && (
            <div className="link" onClick={() => setShowAll(true)}>{`${t("Show all...")}`}</div>
          ) }
        </CheckboxGroup>
      </div>
    </div>
  )
}

export default ProductFilterForm